import React from 'react';
import { Box, Stack } from '@mui/material';
import { getActivityConfig } from './workspaceContracts';

export default function BuddyWorkspace({ activity, header, timeline, composer, outputs, dialogs, children, maxWidth = 980, sx = {} }) {
  const config = getActivityConfig(activity);
  return (
    <Box
      data-buddy-workspace
      data-activity={activity}
      aria-label={`${config.label} buddy workspace`}
      sx={{ width: '100%', maxWidth, mx: 'auto', ...sx }}
    >
      <Stack spacing={2}>
        {header}
        {timeline}
        {children}
        {outputs}
        {composer}
      </Stack>
      {dialogs}
    </Box>
  );
}
